import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from 'react-daisyui';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import { cn } from '@/utils/classNames.ts';
import Routes from '@/router/Routes.ts';
import useRetryTripGeneration from '@/hooks/useRetryTripGeneration.ts';

type TripGenerationFailedProps = PropsWithClassName<{
  tripId: string;
}>;

const TripGenerationFailed: FC<TripGenerationFailedProps> = ({ className, tripId }) => {
  const { t } = useTranslation();
  const { retry, retryingTripId } = useRetryTripGeneration();

  return (
    <div className={cn('flex flex-col justify-center items-center text-center gap-4 p-4 grow', className)}>
      <h1 className="font-medium text-3xl">{t('tripGenerationFailedComponent.header')}</h1>
      <p className="text-[#9CA3AF] text-base">{t('tripGenerationFailedComponent.info')}</p>
      <p className="text-sm text-text-secondary">{t('tripGenerationFailedComponent.retry_is_free')}</p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Button
          color="primary"
          loading={retryingTripId === tripId}
          disabled={retryingTripId !== null}
          onClick={() => void retry(tripId)}
        >
          {t('button.retry')}
        </Button>
        <Link to={Routes.DASHBOARD}>
          <Button color="ghost">{t('button.goBack')}</Button>
        </Link>
      </div>
    </div>
  );
};

export default TripGenerationFailed;
